<!--班车时刻表-->
<template>
  <div class="tw-bcskb">
    <div class="tw-bcskb-head">
      <div class="tw-bcskb-head-title">班车时刻表</div>
      <van-icon
        name="arrow-left"
        size="30"
        color="#fff"
        @click="handleBackClick"
        class="tw-bcskb-head-icon"
      />
    </div>
    <div class="tw-bcskb-body">
      <div class="tw-bcskb-body-head">
        <div class="tw-bcskb-body-head-search">
          <input type="text" placeholder="输入站点/线路" class="tw-bcskb-body-head-search-input" />
        </div>
        <div class="tw-bcskb-body-head-right">
          <van-button type="info" class="tw-bcskb-body-head-right-btn">查&nbsp;询</van-button>
        </div>
      </div>
      <div class="tw-bcskb-body-list">
        <div
          class="tw-bcskb-body-list-item"
          v-for="(item, index) in busTimeList"
          :key="index"
          @click="handleItemClick(item)"
        >
          <div class="tw-bcskb-body-list-item-linename">{{item.linename}}：</div>
          <div class="tw-bcskb-body-list-item-starend">{{item.starend}}</div>
          <div class="tw-bcskb-body-list-item-icon">
            <van-icon name="exchange" size="25" />
          </div>
          <div class="tw-bcskb-body-list-item-timetable">{{item.timeTable}}</div>
          <div style="height:10px;background-color: #9a9fa5;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BusTimetable",
  data() {
    return {
      search: "",
      busTimeList: [
        {
          linename: "教师1号线",
          starend: "玉泉校区-紫金港校区",
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师1号线",
          starend: "玉泉校区-紫金港校区",
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师1号线",
          starend: "玉泉校区-紫金港校区",
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师1号线",
          starend: "玉泉校区-紫金港校区",
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
        {
          linename: "教师1号线",
          starend: "玉泉校区-紫金港校区",
          timeTable: "7:05 7:55 9:00 10:20 12:30 15:00 16:20",
        },
      ],
    };
  },
  methods: {
    //头部返回
    handleBackClick() {
      window.history.go(-1);
    },
    //item点击事件
    handleItemClick(item) {
      console.info(item);
      this.$router.push({
        path: "/bcskb/bcxq",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tw-bcskb {
  height: 100%;
  &-head {
    height: 6%;
    background-color: #3bacff;
    position: relative;
    &-title {
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      letter-spacing: 5px;
      padding-top: 4%;
      color: #ffffff;
      box-sizing: border-box;
    }
    &-icon {
      position: absolute;
      left: 2%;
      top: 20%;
    }
  }
  &-body {
    height: 93%;
    &-head {
      height: 6%;
      width: 100%;
      display: flex;
      border-bottom: 1px solid #9a9fa5;
      &-search {
        width: 70%;
        &-input {
          border: 1px solid #9a9fa5;
          border-radius: 15px;
          height: 70%;
          width: 97%;
          border-radius: 15px;
          margin-top: 2%;
          margin-left: 3%;
        }
      }
      &-right {
        width: 30%;
        &-btn {
          margin-left: 10%;
          margin-top: 2.5%;
          border-radius: 12px;
          width: 80%;
          height: 85%;
          background-color: #3bacff;
        }
      }
    }
    &-list {
      height: 94%;
      &-item {
        height: 14%;
        position: relative;
        &-linename {
          margin-left: 5%;
          padding-top: 1%;
          box-sizing: border-box;
          height: 35%;
        }
        &-starend {
          margin-left: 5%;
          height: 30%;
        }
        &-timetable {
          height: 20%;
          color: #2070fd;
          margin-left: 5%;
        }
        &-icon {
          position: absolute;
          right: 10%;
          top: 15%;
        }
      }
    }
  }
}
</style> 